document.addEventListener('DOMContentLoaded', () => {
    //video_interaction
    document.addEventListener("click", function (e) {
        // Check clicked element or closest parent has .rf-video-controls
        const controls = e.target.closest(".rf-video-controls");
        if(controls){
        let ctaText = "";
        // Check active state
        const playIcon = controls.querySelector(".play-icon");
        const pauseIcon = controls.querySelector(".pause-icon");
        if (playIcon && playIcon.classList.contains("active")) {
            ctaText = "pause";
        } else if (pauseIcon && pauseIcon.classList.contains("active")) {
            ctaText = "play";
        }
        // Find parent product container
        const productWrap = controls.closest(".rf-one-product");
        // Get section/product name
        let sectionName = "";
        if (productWrap) {
            const titleEl = productWrap.querySelector(".rf-product-title a");
            if (titleEl) {
            sectionName = titleEl.innerHTML.trim();
            }
        }
        // DataLayer push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "video_interaction",
            page_type: getPageType(),
            platform: getPlatform(),
            product_name: sectionName,
            cta_text: ctaText
        });
        }
    });
    document.addEventListener("click", function (e) {
        // Check clicked element or closest parent has .rf-video-controls
        const controls = e.target.closest(".rf-video-audio");
        if(controls){
        let ctaText = "";
        // Check active state
        const playIcon = controls.querySelector(".mute-icon");
        const pauseIcon = controls.querySelector(".unmute-icon");
        if (playIcon && playIcon.classList.contains("active")) {
            ctaText = "unmute";
        } else if (pauseIcon && pauseIcon.classList.contains("active")) {
            ctaText = "mute";
        }
        // Find parent product container
        const productWrap = controls.closest(".rf-one-product");
        // Get section/product name
        let sectionName = "";
        if (productWrap) {
            const titleEl = productWrap.querySelector(".rf-product-title a");
            if (titleEl) {
            sectionName = titleEl.innerHTML.trim();
            }
        }
        // DataLayer push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "video_interaction",
            page_type: getPageType(),
            platform: getPlatform(),
            product_name: sectionName,
            cta_text: ctaText
        });
        }
    });

    // cta_click
    document.addEventListener('click', function (e) {
        const el = e.target.closest('[data-cta_text]');
        if (el) {
            const ctaText = el.getAttribute('data-cta_text');
            const sectionName = el.getAttribute('data-section_name');
            console.log('CTA clicked:', ctaText);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "cta_click",
                page_type: getPageType(),
                platform: getPlatform(),
                section_name: sectionName.trim(),
                cta_text: ctaText
            });
        }
    });

    // view_promotion
    function trackPromotionViews() {
        const promotionBanners = document.querySelectorAll('[data-view_promotion]');
        if(promotionBanners.length > 0){
        const observer = new IntersectionObserver((entries) => {
            let creativeName;
            let creativeSlot;
            let promotionId;
            let promotionName;
            entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const banner = entry.target;

                // Skip already tracked banners
                if (banner.dataset.tracked === "true") return;

                banner.dataset.tracked = "true";

                creativeName = banner.getAttribute('data-creative_name') || 'Unknown Banner';
                creativeSlot = banner.getAttribute('data-creative_slot') || 'NA';
                promotionId = banner.getAttribute('data-promotion_id') || 'NA';
                promotionName = banner.getAttribute('data-promotion_name') || creativeName;
            }
            });
            if (creativeName != null) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'view_promotion_ce',
                    page_type: getPageType(),
                    user_id_event: getUserId(),
                    user_status: getUserType(),
                    platform: getPlatform(),
                    ecommerce :{
                        creative_name: creativeName,
                        creative_slot: '1',
                        promotion_id: promotionId,
                        promotion_name: promotionName,
                    }
                });
            }
        }, {
            threshold: 0.5, // at least 50% visible
        });
        promotionBanners.forEach((banner) => observer.observe(banner));
        }
    }
    trackPromotionViews();

    // select_promotion
    function trackPromotionSelection() {
        const promoBanners = document.querySelectorAll('[data-view_promotion]');
        promoBanners.forEach((banner) => {
            banner.addEventListener('click', () => {
                let creativeName = banner.getAttribute('data-creative_name') || 'Unknown Banner';
                let creativeSlot = banner.getAttribute('data-creative_slot') || 'NA';
                let promotionId = banner.getAttribute('data-promotion_id') || 'NA';
                let promotionName = banner.getAttribute('data-promotion_name') || creativeName;
                if (creativeName != null) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ ecommerce: null });
                    window.dataLayer.push({
                        event: 'select_promotion_ce',
                        page_type: getPageType(),
                        user_id_event: getUserId(),
                        user_status: getUserType(),
                        platform: getPlatform(),
                        ecommerce :{
                            creative_name: creativeName,
                            creative_slot: '1',
                            promotion_id: promotionId,
                            promotion_name: promotionName,
                        }
                    });
                }
            });
        });
    }
    trackPromotionSelection();

    // view_item_list
    const productCardsVIL = Array.from(document.querySelectorAll(".product-card-wrapper"));
    if(productCardsVIL){
    window.dataLayer = window.dataLayer || [];
    const seenCards = new Set();
    let item_list_id = "NA";
    let item_list_name = "NA";
    const buildItemFromCard = (card) => {
        let sort_applied = "NA";
        let activeFilters = [];
        if(document.body.classList.contains("template-collection")){
            sort_applied = document.querySelector(`.facets__form [name="sort_by"]`).selectedOptions[0].text;
            if(window.innerWidth <= 767){
                sort_applied = document.querySelector(`form.mobile-facets [name="sort_by"]`).selectedOptions[0].text;
            }
            document.querySelectorAll("facet-filters-form.small-hide input:checked").forEach((input) => {
                const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "NA";
                const labelText = input.value;
                activeFilters.push(`${groupLabel}-${labelText}`);
            });
            if(window.innerWidth <= 767){
                activeFilters = [];
                document.querySelectorAll(".mobile-facets__wrapper input:checked").forEach((input) => {
                    const groupLabel = input.closest("details")?.querySelector("summary span")?.innerHTML.trim() || "Unknown Group";
                    const labelText = input.value;
                    activeFilters.push(`${groupLabel}-${labelText}`);
                });
            }
        }
        let appliedValue = activeFilters.length > 0 ? activeFilters.join("|") : "NA";
        // console.log("appliedValue",appliedValue,sort_applied);

        item_list_id = card.closest('[data-item_list_id]').dataset.item_list_id || 'NA';
        item_list_name = card.closest('[data-item_list_name]').dataset.item_list_name || 'NA';

        return {
            index: parseFloat(card.getAttribute('data-item-index')) || 1,
            item_brand: 'Stosi',
            item_id: card.getAttribute('data-item-id'),
            item_name: card.getAttribute('data-item-name') || 'Unknown Product',
            // item_variant: card.getAttribute('data-item-variant') || 'NA',
            item_variant: 'NA',
            price: parseFloat(card.getAttribute('data-item-price')) || 0,
            item_category: card.getAttribute('data-item-category') || 'NA',
            item_category2: card.getAttribute('data-item-category2') || 'NA',
            item_category3: card.getAttribute('data-item-category3') || 'NA',
            // item_category4: card.getAttribute('data-item-category4') || 'NA',
            // item_category5: card.getAttribute('data-item-category5') || 'NA',
            item_category4: sort_applied,
            item_category5: appliedValue,
            item_list_id: item_list_id,
            item_list_name: item_list_name
        };
    };

    // IntersectionObserver to detect when cards enter viewport
    const observer = new IntersectionObserver(
        (entries) => {
            // console.log("entriesentries>>>>>",entries);
            const visibleItems = [];
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                const card = entry.target;
                // console.log("card>>>>",card);
                // Prevent duplicate event firing using class
                if (!card.classList.contains("gtm-pushed")) {

                    // Add class once pushed
                    card.classList.add("gtm-pushed");

                    visibleItems.push(buildItemFromCard(card));
                }
                }
            });
            if (visibleItems.length) {
                // Push GA4 event only for newly visible items
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                event: "view_item_list_ce",
                page_type: getPageType(),
                user_id_event: getUserId(),
                user_status: getUserType(),
                platform: getPlatform(),
                ecommerce: { item_list_id: item_list_id, item_list_name: item_list_name, items: visibleItems },
                });
            }
        },
        {
        threshold: 0.5, // 50% of card in viewport; tweak as needed
        }
    );
    productCardsVIL.forEach((card) => observer.observe(card));
    }

    function view_item_list_search(){
        // console.log("view_item_list_search>>>>>");
        // view_item_list
        const productCardsVIL = Array.from(document.querySelectorAll(".box-productq"));
        // console.log("productCardsVIL",productCardsVIL);
        if(productCardsVIL){
        window.dataLayer = window.dataLayer || [];
        const seenCards = new Set();
        let item_list_id = "NA";
        let item_list_name = "NA";
        const buildItemFromCard = (card) => {
            let sort_applied = "NA";
            let activeFilters = [];
            if(document.body.classList.contains("template-collection")){
                sort_applied = document.querySelector(`.facets__form [name="sort_by"]`).selectedOptions[0].text;
                if(window.innerWidth <= 767){
                    sort_applied = document.querySelector(`form.mobile-facets [name="sort_by"]`).selectedOptions[0].text;
                }
                document.querySelectorAll("facet-filters-form.small-hide input:checked").forEach((input) => {
                    const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "NA";
                    const labelText = input.value;
                    activeFilters.push(`${groupLabel}-${labelText}`);
                });
                if(window.innerWidth <= 767){
                    activeFilters = [];
                    document.querySelectorAll(".mobile-facets__wrapper input:checked").forEach((input) => {
                        const groupLabel = input.closest("details")?.querySelector("summary span")?.innerHTML.trim() || "Unknown Group";
                        const labelText = input.value;
                        activeFilters.push(`${groupLabel}-${labelText}`);
                    });
                }
            }
            let appliedValue = activeFilters.length > 0 ? activeFilters.join("|") : "NA";
            // console.log("appliedValue",appliedValue,sort_applied);

            item_list_id = card.closest('[data-item_list_id]').dataset.item_list_id || 'NA';
            item_list_name = card.closest('[data-item_list_name]').dataset.item_list_name || 'NA';

            return {
                index: parseFloat(card.getAttribute('data-item-index')) || 1,
                item_brand: 'Stosi',
                item_id: card.getAttribute('data-item-id'),
                item_name: card.getAttribute('data-item-name') || 'Unknown Product',
                // item_variant: card.getAttribute('data-item-variant') || 'NA',
                item_variant: 'NA',
                price: parseFloat(card.getAttribute('data-item-price')) || 0,
                item_category: card.getAttribute('data-item-category') || 'NA',
                item_category2: card.getAttribute('data-item-category2') || 'NA',
                item_category3: card.getAttribute('data-item-category3') || 'NA',
                // item_category4: card.getAttribute('data-item-category4') || 'NA',
                // item_category5: card.getAttribute('data-item-category5') || 'NA',
                item_category4: sort_applied,
                item_category5: appliedValue,
                item_list_id: item_list_id,
                item_list_name: item_list_name
            };
        };

        // IntersectionObserver to detect when cards enter viewport
        const observer = new IntersectionObserver(
            (entries) => {
                // console.log("entriesentries>>>>>",entries);
                const visibleItems = [];
                let productCardsVIL1 = Array.from(document.querySelectorAll(".box-productq"));
                // console.log("productCardsVIL1",productCardsVIL1);
                let countIndex = 0;
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        countIndex++;
                        if(countIndex == 1){
                        productCardsVIL1.forEach((card) => {
                            if (!card.classList.contains("gtm-pushed")) {

                                // Add class once pushed
                                card.classList.add("gtm-pushed");

                                visibleItems.push(buildItemFromCard(card));
                            }
                        });
                        }
                    }
                });
                if (visibleItems.length) {
                    // Push GA4 event only for newly visible items
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                    event: "view_item_list_ce",
                    page_type: getPageType(),
                    user_id_event: getUserId(),
                    user_status: getUserType(),
                    platform: getPlatform(),
                    ecommerce: { item_list_id: item_list_id, item_list_name: item_list_name, items: visibleItems },
                    });
                }
            },
            {
            threshold: 0.5, // 50% of card in viewport; tweak as needed
            }
        );
        productCardsVIL.forEach((card) => observer.observe(card));
        }
    }
    view_item_list_search();


    // select_item init
    if(!document.body.classList.contains("template-product")){
        selectItemInit();
    }
    selectItemInitSEARCH();


    //begin_checkout

    document.addEventListener("click",function (event) {
        const btn = event.target.closest(".gokwik-checkout button, #gokwik-checkout-btn, .gk-checkout-btn");
        if (btn) {
            console.log("btn",btn);
            const cartItems = [];
            document.querySelectorAll(`.cart-item`).forEach(item => {
                let addedItem = JSON.parse(localStorage.getItem(`datalayer_${item.dataset.productId}`));
                console.log("addedItem",addedItem);
                addedItem.quantity = parseInt(item.dataset.quantity);
                cartItems.push(addedItem);
            });
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "begin_checkout_ce",
                page_type: getPageType(),
                user_id_event: getUserId(),
                user_status: getUserType(),
                platform: getPlatform(),
                ecommerce: {
                    currency: 'INR',
                    value: parseFloat(document.querySelector(`cart-drawer [data-total-value]`).dataset.totalValue),
                    coupon: "NA",
                    coupon_amount: "NA",
                    items: cartItems 
                },
            });
        }
    },
    true // <-- IMPORTANT: capture phase before GoKwik overrides it
    );
    
    

});

// select_item
function selectItemInit(){
    // console.log("selectItemInit>>>>>");
    setTimeout(() => {
    const viewedProducts = new Set();
    let item_list_id = "NA";
    let item_list_name = "NA";
    const productCards = document.querySelectorAll('.product-card-wrapper');
    // console.log("selectItemInit>>>>> productCards",productCards)
    if (!productCards.length) return;
    productCards.forEach((card) => {
        card.addEventListener('click', function (event) {
            // Allow only clicks on product card or its children
            if (!event.target.closest('.product-card-wrapper, .box-productq')) return;
            let sort_applied = "NA";
            let activeFilters = [];
            if(document.body.classList.contains("template-collection")){
                sort_applied = document.querySelector(`.facets__form [name="sort_by"]`).selectedOptions[0].text;
                if(window.innerWidth <= 767){
                    sort_applied = document.querySelector(`form.mobile-facets [name="sort_by"]`).selectedOptions[0].text;
                }
                document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
                    const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
                    const labelText = input.value;
                    activeFilters.push(`${groupLabel}-${labelText}`);
                });

                if(window.innerWidth <= 767){
                    activeFilters = [];
                    document.querySelectorAll(".mobile-facets__wrapper input:checked").forEach((input) => {
                        const groupLabel = input.closest("details")?.querySelector("summary span")?.innerHTML.trim() || "Unknown Group";
                        const labelText = input.value;
                        activeFilters.push(`${groupLabel}-${labelText}`);
                    });
                }
            }
            let appliedValue = activeFilters.length > 0 ? activeFilters.join("|") : "NA";
            item_list_id = card.closest('[data-item_list_id]').dataset.item_list_id || 'NA';
            item_list_name = card.closest('[data-item_list_name]').dataset.item_list_name || 'NA';

            // Prepare GA4 item object
            const itemData = {
                index: parseFloat(card.getAttribute('data-item-index')) || 1,
                item_brand: 'Stosi',
                item_id: card.getAttribute('data-item-id'),
                item_name: card.getAttribute('data-item-name') || 'Unknown Product',
                // item_variant: card.getAttribute('data-item-variant') || 'NA',
                item_variant: 'NA',
                price: parseFloat(card.getAttribute('data-item-price')) || 0,
                item_category: card.getAttribute('data-item-category') || 'NA',
                item_category2: card.getAttribute('data-item-category2') || 'NA',
                item_category3: card.getAttribute('data-item-category3') || 'NA',
                // item_category4: card.getAttribute('data-item-category4') || 'NA',
                // item_category5: card.getAttribute('data-item-category5') || 'NA',
                item_category4: sort_applied,
                item_category5: appliedValue,
                item_list_id: item_list_id,
                item_list_name: item_list_name
            };
            localStorage.setItem(`item_list_id_${card.getAttribute('data-item-id')}`, card.closest('[data-item_list_id]').dataset.item_list_id || 'NA');
            localStorage.setItem(`item_list_name_${card.getAttribute('data-item-id')}`, card.closest('[data-item_list_name]').dataset.item_list_name || 'NA');
            localStorage.setItem(`item_category2_${card.getAttribute('data-item-id')}`, card.getAttribute('data-item-category2') || 'NA');
            localStorage.setItem(`index_${card.getAttribute('data-item-id')}`, parseFloat(card.getAttribute('data-item-index')) || 1);
            // GA4 push
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'select_item_ce',
                page_type: getPageType(),
                user_id_event: getUserId(),
                user_status: getUserType(),
                platform: getPlatform(),
                ecommerce: { item_list_id: item_list_id, item_list_name: item_list_name, items: [itemData] }
            });
        });
    });
    },2000);
}
function selectItemInitSEARCH(){
    // console.log("selectItemInit>>>>>");
    setTimeout(() => {
    const viewedProducts = new Set();
    let item_list_id = "NA";
    let item_list_name = "NA";
    const productCards = document.querySelectorAll('.box-productq');
    // console.log("selectItemInit>>>>> productCards",productCards)
    if (!productCards.length) return;
    productCards.forEach((card) => {
        card.addEventListener('click', function (event) {
            // Allow only clicks on product card or its children
            if (!event.target.closest('.product-card-wrapper, .box-productq')) return;
            let sort_applied = "NA";
            let activeFilters = [];
            if(document.body.classList.contains("template-collection")){
                sort_applied = document.querySelector(`.facets__form [name="sort_by"]`).selectedOptions[0].text;
                if(window.innerWidth <= 767){
                    sort_applied = document.querySelector(`form.mobile-facets [name="sort_by"]`).selectedOptions[0].text;
                }
                document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
                    const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
                    const labelText = input.value;
                    activeFilters.push(`${groupLabel}-${labelText}`);
                });

                if(window.innerWidth <= 767){
                    activeFilters = [];
                    document.querySelectorAll(".mobile-facets__wrapper input:checked").forEach((input) => {
                        const groupLabel = input.closest("details")?.querySelector("summary span")?.innerHTML.trim() || "Unknown Group";
                        const labelText = input.value;
                        activeFilters.push(`${groupLabel}-${labelText}`);
                    });
                }
            }
            let appliedValue = activeFilters.length > 0 ? activeFilters.join("|") : "NA";
            item_list_id = card.closest('[data-item_list_id]').dataset.item_list_id || 'NA';
            item_list_name = card.closest('[data-item_list_name]').dataset.item_list_name || 'NA';

            // Prepare GA4 item object
            const itemData = {
                index: parseFloat(card.getAttribute('data-item-index')) || 1,
                item_brand: 'Stosi',
                item_id: card.getAttribute('data-item-id'),
                item_name: card.getAttribute('data-item-name') || 'Unknown Product',
                // item_variant: card.getAttribute('data-item-variant') || 'NA',
                item_variant: 'NA',
                price: parseFloat(card.getAttribute('data-item-price')) || 0,
                item_category: card.getAttribute('data-item-category') || 'NA',
                item_category2: card.getAttribute('data-item-category2') || 'NA',
                item_category3: card.getAttribute('data-item-category3') || 'NA',
                // item_category4: card.getAttribute('data-item-category4') || 'NA',
                // item_category5: card.getAttribute('data-item-category5') || 'NA',
                item_category4: sort_applied,
                item_category5: appliedValue,
                item_list_id: item_list_id,
                item_list_name: item_list_name
            };
            localStorage.setItem(`item_list_id_${card.getAttribute('data-item-id')}`, card.closest('[data-item_list_id]').dataset.item_list_id || 'NA');
            localStorage.setItem(`item_list_name_${card.getAttribute('data-item-id')}`, card.closest('[data-item_list_name]').dataset.item_list_name || 'NA');
            localStorage.setItem(`item_category2_${card.getAttribute('data-item-id')}`, card.getAttribute('data-item-category2') || 'NA');
            localStorage.setItem(`index_${card.getAttribute('data-item-id')}`, parseFloat(card.getAttribute('data-item-index')) || 1);
            // GA4 push
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'select_item_ce',
                page_type: getPageType(),
                user_id_event: getUserId(),
                user_status: getUserType(),
                platform: getPlatform(),
                ecommerce: { item_list_id: item_list_id, item_list_name: item_list_name, items: [itemData] }
            });
        });
    });
    },2000);
}